export default (el) => {
    let pageHeader = document.querySelector('.page-header');
    let main = document.querySelector('.main');

    // Toggle function
    const toggleItem = () => {
        el.classList.toggle('is-active');
        pageHeader.classList.toggle('-open');
    };

    // Toggle nav
    el.addEventListener('click', toggleItem);

    // Close function
    const closeMenu = () => {
        el.classList.remove('is-active');
        pageHeader.classList.remove('-open');
    };

    // Close mobile nav when window.innerwidth > 630px
    window.addEventListener('resize', () => {
        if (window.innerWidth > 630) {
            closeMenu();
        }
    });

    // Close mobile nav by clicking in main
    main.addEventListener('click', () => {
        if (el.classList.contains('is-active') === true) {
            closeMenu();
        }
    });
};
